<template>
  <div class="news-detail">
    <img class="banner" :src="newsDetail.thumb_img" />
    <p class="title">{{ newsDetail.title }}</p>
    <div class="number">
      <p>{{ newsDetail.click_rate }}次预览</p>
      <p>{{ newsDetail.created_at | fomartTime("MM-dd") }}</p>
    </div>
    <p class="abstract">{{ newsDetail.description }}</p>
    <div class="detail" v-html="newsDetail.content"></div>
    <!-- <back-spell :config="{redirect:'Index',title: '返回首页'}" v-if="$route.query.share_source"></back-spell> -->
  </div>
</template>

<script>
export default {
  name: "news-detail",
  data() {
    return {
      id: this.$route.query.id,
      newsDetail: {} // 新闻详情
    };
  },
  created() {
    this.requestDetail();
  },
  methods: {
    // request
    requestDetail() {
      this.$http
        .post("/api/app/information/detail", {
          information_id: this.id
        })
        .then(data => {
          this.newsDetail = data;
          // 咨询详情分享
          this.$store.dispatch("setShare", {
            share_type: 2,
            route: this.$route,
            web_title: data.title,
            web_description: data.description,
            mobile_logo: data.thumb_img
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.news-detail {
  background-color: #fff;
  .banner {
    display: block;
    width: 100%;
  }
  .title {
    padding: 20px 40px;
    font-size: 45px;
    color: #222;
    line-height: 66px;
  }
  .number {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 40px;
    p {
      font-size: 24px;
      color: #b7b7b7;
      line-height: 24px;
    }
  }
  .abstract {
    position: relative;
    padding: 60px 85px;
    text-align: center;
    font-size: 32px;
    color: #999;
    line-height: 49px;
    &:after {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 195px;
      height: 3px;
      background-color: #ededed;
      content: "";
    }
  }
  .detail {
    margin-top: 55px;
    padding: 0 40px 40px;
    font-size: 34px;
    & /deep/ img, & /deep/ video {
      width: 100%!important;
      height: auto!important;
    }
  }
}
</style>
